(() => {
  'use strict';
  const root = window.Yure?.root || '/';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const money = cents => new Intl.NumberFormat(window.Yure?.locale || 'en', { style: 'currency', currency: window.Yure?.currency || 'GBP' }).format(Number(cents || 0) / 100) + ' ' + (window.Yure?.currency || 'GBP');
  const announce = message => { const el = $('#LiveRegion'); if (el) el.textContent = message; };
  let lastFocus;
  const openDialog = id => {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    lastFocus = document.activeElement;
    $$('dialog[open]').forEach(d => d.close());
    dialog.showModal();
    const focus = $('input:not([type=hidden]),button,a', dialog);
    if (focus) focus.focus();
  };
  const closeDialog = dialog => { dialog?.close(); if (lastFocus?.isConnected) lastFocus.focus(); };
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-open]');
    if (opener) openDialog(opener.dataset.open);
    const closer = event.target.closest('[data-close]');
    if (closer) closeDialog(closer.closest('dialog'));
    if (event.target.tagName === 'DIALOG') {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(event.target);
    }
    const cartOpener = event.target.closest('[data-cart-open]');
    if (cartOpener && window.Yure.cartMode === 'drawer') { event.preventDefault(); openDialog('CartDrawer'); }
    const media = event.target.closest('[data-media-target]');
    if (media) activateMedia(media.closest('[data-gallery]'), media.dataset.mediaTarget);
    const zoom = event.target.closest('[data-zoom],[data-zoom-reference]');
    if (zoom) {
      const content = $('#ZoomDialog [data-zoom-content]');
      content.replaceChildren();
      if (zoom.dataset.zoom) { const img = new Image(); img.src = zoom.dataset.zoom; img.alt = $('img', zoom)?.alt || ''; content.append(img); }
      else { const art = $('.reference-art', zoom); if (art) content.append(art.cloneNode(true)); }
      openDialog('ZoomDialog');
    }
    const quantityStep = event.target.closest('[data-quantity-step]');
    if (quantityStep) { const input = $('input', quantityStep.closest('.quantity-control')); input.value = Math.max(1, (Number(input.value) || 1) + Number(quantityStep.dataset.quantityStep)); input.dispatchEvent(new Event('change', { bubbles: true })); }
    const step = event.target.closest('[data-cart-step]');
    if (step) {
      const row = step.closest('[data-cart-key]'), input = $('[data-cart-quantity]', row);
      input.value = Math.max(0, (Number(input.value) || 0) + Number(step.dataset.cartStep));
      if (step.closest('#CartDrawer')) await changeCart(row, Number(input.value));
    }
    const remove = event.target.closest('#CartDrawer [data-cart-remove]');
    if (remove) { event.preventDefault(); await changeCart(remove.closest('[data-cart-key]'), 0); }
    const unit = event.target.closest('[data-unit]');
    if (unit) {
      const guide = unit.closest('[data-size-guide]');
      $$('[data-unit]', guide).forEach(btn => btn.setAttribute('aria-pressed', String(btn === unit)));
      $$('[data-inches]', guide).forEach(cell => { const n = inches(cell.dataset.inches); cell.textContent = unit.dataset.unit === 'cm' && Number.isFinite(n) ? (n * 2.54).toFixed(1) : cell.dataset.inches; });
    }
    const tab = event.target.closest('[data-tab]');
    if (tab) switchTab(tab);
  });
  document.addEventListener('keydown', event => {
    if (event.target.matches('[role=tab]') && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      event.preventDefault(); const tabs = $$('[role=tab]', event.target.parentElement); let i = tabs.indexOf(event.target);
      i = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      switchTab(tabs[i]); tabs[i].focus();
    }
  });
  const switchTab = tab => {
    const guide = tab.closest('[data-size-guide]');
    $$('[data-tab]', guide).forEach(btn => { const on = btn === tab; btn.setAttribute('aria-selected', String(on)); btn.tabIndex = on ? 0 : -1; });
    $$('.guide-pane', guide).forEach(pane => pane.hidden = pane.id !== tab.dataset.tab);
  };
  function inches(value) {
    const normalized = value.trim().replace(/½/g, ' 1/2').replace(/¼/g, ' 1/4').replace(/¾/g, ' 3/4');
    if (!normalized || /[^\d\s./-]/.test(normalized)) return NaN;
    return normalized.split(/\s+/).reduce((total, part) => { const bits = part.split('/').map(Number); return total + (bits.length === 2 ? bits[0] / bits[1] : bits[0]); }, 0);
  }
  function activateMedia(gallery, id) {
    if (!gallery) return;
    $$('.gallery-panel', gallery).forEach(panel => {
      panel.hidden = panel.id !== id;
      if (panel.hidden) { $$('video', panel).forEach(v => v.pause()); $$('iframe', panel).forEach(f => { if (f.src) f.src = f.src; }); }
    });
    $$('[data-media-target]', gallery).forEach(btn => btn.setAttribute('aria-pressed', String(btn.dataset.mediaTarget === id)));
  }
  let cartBusy = false;
  async function refreshCart(cartData) {
    $$('[data-cart-count]').forEach(el => el.textContent = cartData.item_count ?? el.textContent);
    let html = cartData.sections?.['cart-drawer'];
    if (!html) { const response = await fetch(root + '?sections=cart-drawer'); if (!response.ok) throw new Error('Your bag was updated. Open the cart page to review it.'); html = (await response.json())['cart-drawer']; }
    if (!html) throw new Error('Your bag was updated. Open the cart page to review it.');
    const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
    if (!fresh) throw new Error('Your bag was updated. Open the cart page to review it.');
    const current = $('#CartDrawer'); current.innerHTML = fresh.innerHTML;
    const count = $('[data-cart-count]', current)?.textContent;
    if (count !== undefined) $$('[data-cart-count]').forEach(el => el.textContent = count);
  }
  async function changeCart(row, quantity) {
    if (cartBusy) return; cartBusy = true;
    const key = row.dataset.cartKey;
    const oldValue = $('[data-cart-quantity]', row)?.defaultValue;
    const error = $('#CartDrawer [data-cart-error]'); if (error) error.textContent = '';
    $$('button,input', $('#CartDrawer')).forEach(el => el.disabled = true);
    try {
      const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, Math.floor(quantity)), sections: ['cart-drawer'], sections_url: location.pathname }) });
      const data = await response.json(); if (!response.ok) throw new Error(data.description || data.message || 'Could not update quantity.');
      await refreshCart(data); announce('Bag updated.');
      const nextRow = $$('[data-cart-key]', $('#CartDrawer')).find(el => el.dataset.cartKey === key);
      const focus = nextRow ? $('[data-cart-quantity]', nextRow) : $('#CartDrawer [data-close]'); focus?.focus();
    } catch (err) { const input = $('[data-cart-quantity]', row); if (input && oldValue) input.value = oldValue; const el = $('#CartDrawer [data-cart-error]'); if (el) el.textContent = err.message; }
    finally { cartBusy = false; $$('button,input', $('#CartDrawer')).forEach(el => el.disabled = false); }
  }
  document.addEventListener('change', event => {
    if (event.target.matches('#CartDrawer [data-cart-quantity]')) {
      const n = Number(event.target.value); if (Number.isFinite(n) && n >= 0) changeCart(event.target.closest('[data-cart-key]'), n);
    }
  });
  function initProduct(section) {
    if (section.dataset.initialized) return; section.dataset.initialized = 'true';
    const form = $('[data-product-form]', section), json = $('[data-product-json]', section);
    if (!form || !json) return;
    let product; try { product = JSON.parse(json.textContent); } catch { return; }
    const variants = product.variants || [], pickers = $$('[data-option-index]', form), variantId = $('[data-variant-id]', form), add = $('[data-add]', form);
    const label = $('[data-add-label]', form), initialLabel = 'Add to Cart';
    const selectedValues = () => pickers.map(p => $('input:checked', p)?.value);
    function updateVariant(changeURL = true) {
      const values = selectedValues();
      const variant = pickers.length ? variants.find(v => v.options.every((opt, i) => opt === values[i])) : variants.find(v => String(v.id) === variantId.value);
      const available = !!variant?.available;
      variantId.value = variant ? variant.id : '';
      add.disabled = !available; label.textContent = !variant ? 'Unavailable' : available ? initialLabel : 'Sold out';
      $$('[data-sticky-add]', section).forEach(el => { el.disabled = !available; el.textContent = label.textContent; });
      if (variant) {
        let price = variant.price;
        const planId = $('[name=selling_plan]', form)?.value;
        const allocation = variant.selling_plan_allocations?.find(a => String(a.selling_plan_id) === planId);
        if (allocation) price = allocation.price;
        $$('[data-product-price],[data-button-price],[data-sticky-price]', section).forEach(el => el.textContent = money(price));
        const compare = $('[data-compare-price]', section); if (compare) { compare.hidden = !(variant.compare_at_price > price); compare.textContent = money(variant.compare_at_price); }
        if (variant.featured_media) { const panel = $(`[data-media-id="${variant.featured_media.id}"]`, section); if (panel) activateMedia($('[data-gallery]', section), panel.id); }
        if (changeURL) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      } else {
        $$('[data-button-price]', section).forEach(el => el.textContent = '—');
        if (changeURL) { const url = new URL(location.href); url.searchParams.delete('variant'); history.replaceState({}, '', url); }
      }
      pickers.forEach((picker, index) => $$('input', picker).forEach(input => {
        const possible = variants.some(v => v.available && v.options[index] === input.value && v.options.every((opt, i) => i >= index || opt === values[i]));
        input.closest('.option-pill').classList.toggle('is-unavailable', !possible);
      }));
      $('[data-product-error]', form).textContent = '';
    }
    form.addEventListener('change', event => { if (event.target.matches('[type=radio],[name=selling_plan]')) updateVariant(); });
    updateVariant(false);
    form.addEventListener('submit', async event => {
      if (window.Yure.cartMode !== 'drawer') return;
      event.preventDefault(); if (add.disabled || form.dataset.busy) return;
      form.dataset.busy = 'true'; add.disabled = true; label.textContent = 'Adding…';
      const error = $('[data-product-error]', form); error.textContent = '';
      try {
        const data = new FormData(form); data.set('sections', 'cart-drawer'); data.set('sections_url', location.pathname);
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        const result = await response.json(); if (!response.ok) throw new Error(result.description || result.message || 'Could not add this item. Please try again.');
        await refreshCart(result); openDialog('CartDrawer'); announce('Added to your bag.');
      } catch (err) { error.textContent = err.message; }
      finally { const message = error.textContent; delete form.dataset.busy; updateVariant(false); error.textContent = message; if (message) announce(message); }
    });
    const sticky = $('.sticky-cart', section);
    if (sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { const entry = entries[0]; sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0); }, { threshold: 0 });
      observer.observe(add); section._yureObserver = observer;
    }
  }
  function init(scope = document) { $$('[data-product-section]', scope).forEach(initProduct); }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => $$('[data-product-section]', event.target).forEach(s => s._yureObserver?.disconnect()));
})();
(() => {
 function initCountries(scope=document) {
  scope.querySelectorAll('[data-country-select]').forEach(country=>{
   if(country.dataset.ready)return;country.dataset.ready='true';
   const province=document.getElementById(country.dataset.province),wrapper=province?.closest('[data-province-wrapper]');
   const setSelected=(select,value)=>{const option=[...select.options].find(o=>o.value===value||o.textContent===value);if(option)select.value=option.value;};
   setSelected(country,country.dataset.default);
   const update=()=>{if(!province)return;let provinces=[];try{provinces=JSON.parse(country.selectedOptions[0]?.dataset.provinces||'[]');}catch{}province.replaceChildren(...provinces.map(p=>new Option(p[1],p[0])));wrapper.hidden=!provinces.length;province.disabled=!provinces.length;};
   update();if(province)setSelected(province,province.dataset.default);country.addEventListener('change',update);
  });
 }
 initCountries();document.addEventListener('shopify:section:load',e=>initCountries(e.target));
})();
